<template>
  <el-dialog
      class="singleSuccessView"
      title="添加完成"
      :before-close="closeView"
       :close-on-click-modal="false"
      :visible.sync="singleSuccessVisible"
      width="500px">
      <el-row class="singleSuccessTitle">
        <span class="el-icon-success"></span>
        <span>添加设备成功，接下来您可以：</span>
      </el-row>
      <div class="flex">
        <div>
          <span class="el-icon-document-add icons"></span>
        </div>
        <div :span="18">
          <div>
            查看设备信息
          </div>
          <div class="showMes">
            设备信息页面包含了：设备信息、运行状态、事件管理、服务调用、设备影子、文件管理，等设备维度的功能集合。
          </div>
          <el-button size="small"  @click="goDetail">前往查看</el-button>
          <el-button size="small" @click="copyCertificate">一键复制设备证书</el-button>
          <el-tooltip :content="singleSuccessTips" placement="right" effect="light">
              <span class="el-icon-question"></span>
            </el-tooltip>
        </div>
      </div>
      <div class="flex">
        <div>
          <span class="el-icon-menu icons"></span>
        </div>
        <div>
          <div>
            烧入 SDK 至设备
          </div>
          <div class="showMes">
            您可以依照您的需求，前往选择不同的语言的 SDK，并复制下方的设备证书，烧入至您的设备。（注：您可以随时在设备信息中，查看此设备的设备证书）
          </div>
          <!-- <el-button size="small">查看 SDK</el-button> -->
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button  type="primary" size="small" @click="closeView">完 成</el-button>
      </span>
     </el-dialog>
</template>
<script>
import { copy } from '@/utils'
export default {
  props: {
    singleSuccessVisible: {
      type: Boolean
    },
    singleAddDetail: {
      type: Object
    }
  },
  data () {
    return {
      singleSuccessTips: '设备证书用于云端对接入的设备做鉴权认证，请妥善保管！'
    }
  },
  methods: {
    goDetail () {
      this.$store.commit('SET_DEVICE_DETAIL', JSON.stringify(this.singleAddDetail.addSingleDetail))// 把设备详情缓存起来，很多地方用到,缓存成字符串，防止修改操作到对象
      this.$router.push({
        name: 'hasParent/deviceManagement/DeviceManager'
      })
    },
    closeView () {
      this.$emit('closeView')
    },
    copyCertificate () {
      // 设备添加完毕后复制证书
      copy(JSON.stringify(this.singleAddDetail.deviceSecret), () => {
        this.$message({
          type: 'success',
          message: '复制成功'
        })
      })
    }
  }
}
</script>
<style lang="less" scope>
.singleSuccessView{
    .flex{
      display: flex;
      margin-top: 20px;
    }
    .icons{
      color: #409EFF;
      font-size: 45px;
      margin-right: 10px;
    }
    .el-icon-success{
      color: rgb(30, 142, 62);
      margin-right: 10px;
    }
    .el-icon-question{
      margin-left: 10px;
      color: rgb(204, 204, 204);
    }
    .singleSuccessTitle{
      font-size: 18px;
    }
    .showMes{
      font-size: 12px;
      line-height: 20px;
      margin-bottom: 10px;
    }
  }
</style>
